import {
  Mousewheel,
  Keyboard,
  Autoplay,
  Navigation,
  Pagination,
} from "swiper/modules";
import Swiper from "swiper";

class SwiperSlider extends HTMLElement {
  constructor() {
    super();
    const customSliderElement = this;
    const swiperHolder = customSliderElement.querySelector(".swiper");
    const enableLoop = customSliderElement.getAttribute("data-loop");
    const enableAutoplay = customSliderElement.getAttribute("data-autoplay");
    const autoplaySpeed = customSliderElement.getAttribute(
      "data-autoplay-speed"
    );
    const enableKeyboard = customSliderElement.getAttribute("data-keyboard");
    const swiperButtonNext = customSliderElement.querySelector(
      ".swiper-button-next"
    );
    const slidePerView = customSliderElement.getAttribute("data-slides-per-view");
    const slidePerViewMobile = customSliderElement.getAttribute("data-slides-per-view-mobile");
    const swiperButtonPrevious = customSliderElement.querySelector(
      ".swiper-button-previous"
    );

    const slide = this.querySelectorAll(".swiper-slide");

    slide.forEach((element) => {
      element.addEventListener("click", () => {
      });
    });
    const mobileBreakpoint = 320;
    const desktopBreakpoint = 640;
    const swiperConfig = {
      modules: [Mousewheel, Navigation],
      mousewheel: {
        forceToAxis: true,
      },
      direction: "horizontal",
      navigation: {
        enabled: true,
        nextEl: swiperButtonNext,
        prevEl: swiperButtonPrevious,
      },
      threshold: 10,
      edgeSwipeDetection: true,

      breakpoints: {
        // when window width is >= 320px
        [mobileBreakpoint]: {
          slidesPerView: slidePerViewMobile,
          spaceBetween: 12,
        },
        // when window width is >= 480px
        [desktopBreakpoint]: {
          slidesPerView: slidePerView,
          spaceBetween: 16,
        },
      },
    };

    if (enableAutoplay && enableAutoplay === "true") {
      swiperConfig.modules = swiperConfig.modules
        ? [...swiperConfig.modules, Autoplay]
        : [Autoplay];
    }

    if (enableLoop && enableLoop === "true") {
      swiperConfig.loop = true;
    }

    if (autoplaySpeed && autoplaySpeed > 0) {
      swiperConfig.autoplay = {
        disableOnInteraction: false,
        pauseOnMouseEnter: true,
        delay: autoplaySpeed,
      };
    }

    if (enableKeyboard && enableKeyboard === "true") {
      swiperConfig.modules = swiperConfig.modules
        ? [...swiperConfig.modules, Keyboard]
        : [Keyboard];
      swiperConfig.keyboard = {
        enabled: true,
      };
    }

    new Swiper(swiperHolder, swiperConfig);

    window.addEventListener(
      "shopify:section:load",
      () => new Swiper(swiperHolder, swiperConfig)
    );
  }
}

// Check if element is defined, if not define it.
// eslint-disable-next-line no-undefined
if (customElements.get("swiper-slider") === undefined) {
  customElements.define("swiper-slider", SwiperSlider);
}
